export interface ITaxEquityDetails {
  taxEquityDetailId: number;
  itcPercent: number;
  taxAllocationPercent: number;
  funding: number;
  preFlipAnnualReturnRate: number;
  postFlipEbitdaPercent: number;
  preFlipCommonCashSharePercent: number;
}

export class TaxEquityDetails implements ITaxEquityDetails {
  taxEquityDetailId: number;
  itcPercent: number;
  taxAllocationPercent: number;
  funding: number;
  preFlipAnnualReturnRate: number;
  postFlipEbitdaPercent: number;
  preFlipCommonCashSharePercent: number;
}
